/**
 * Se trata de un Modelo de la estructura escolar, por ejemplo el Curso o Ensennanza etc:
 * {
     "type": "anno_lectivo",
     "id": 1029,
     "anno": "2024-2025",
     "nombre": "2024-2025",
   }
 */
export default class Modelo {
  constructor(data, _options = {}) {
    Object.assign(this, data);
  }

  get label() {
    return this._label || this.etiqueta || this.abbr || this.nombre;
  }

  set label(valor) {
    this._label = valor;
  }
}
